module.exports = __webpack_public_path__ + "static/media/success.737ad5e2.svg";